import { Component } from 'react';
import CommerceFilterIntent from '../../../../../../components/CommerceFilterIntent';

class ExtraBox extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <CommerceFilterIntent
                            select={this.props.select}
                            handleSelectChange={this.props.handleSelectChange}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBox;
